export default __webpack_public_path__ + "static/media/warning--added-lane-left--g1.a8c7833e.png";